function brandHttpRequest(theUrl,obj){
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.overrideMimeType("application/json");
   xmlHttp.open('GET', theUrl, true);
      xmlHttp.onload  = function() {
      if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
        var data = xmlHttp.responseText;
        var dataCollection = JSON.parse(data);
        obj.addClass("pcount-"+dataCollection.collection["products_count"]);
    }
    }
    xmlHttp.send(null);
}
function hideZeroProductsBrands(){
  $("#all_brands").find("a.brand-page-text-black").each(function(){
    var url = $(this).attr("href");
    if(url){
      if(url.length > 0 && url.indexOf("collections") > -1){
        var countProductsURL = url+"/products_count.json";
        brandHttpRequest(countProductsURL, $(this).parent().parent().parent());
      }
    }  
 });
}
